import * as types from '../actions/ActionTypes';

const initialState = {
  loading: false,
  error: '',
  success: false,
};

export default function review(state = initialState, action) {
  switch (action.type) {
    case types.GIFT_CARD_FORM_LOADING_START:
      return { ...state, loading: true };
    case types.GIFT_CARD_FORM_LOADING_STOP:
      return { ...state, loading: false };
    case types.PURCHASE_GIFT_CARD_REQUEST:
      return { ...state, loading: true, success: false };
    case types.PURCHASE_GIFT_CARD_SUCCESS:
      return { ...state, error: '', loading: false, success: true };
    case types.PURCHASE_GIFT_CARD_FAILURE:
      const error =
        action.payload.error ||
        (action.payload?.errors && action.payload?.errors[0]?.message) ||
        'Something went wrong'; // We handle errors differently on the API based on the type of error :( Need to fix in v4 API

      return { ...state, error, loading: false, success: false };
    case types.RESET_GIFT_CARD_STATE:
      return initialState;
    default:
      return state;
  }
}
